module.exports = __webpack_public_path__ + "img/022.13339384.jpg";